import type { RefObject } from "react";
import { useEffect, useRef } from "react";


export const useAutofocus = <T extends HTMLElement>(): RefObject<T> => {
	const ref = useRef<T>(null);
	useEffect(() => {
		ref.current?.focus();
	}, []);

	return ref as RefObject<T>;
};
